import { render, staticRenderFns } from "./RoomCBTInfoForm.vue?vue&type=template&id=7ffd6d24&"
import script from "./RoomCBTInfoForm.vue?vue&type=script&lang=js&"
export * from "./RoomCBTInfoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ffd6d24')) {
      api.createRecord('7ffd6d24', component.options)
    } else {
      api.reload('7ffd6d24', component.options)
    }
    module.hot.accept("./RoomCBTInfoForm.vue?vue&type=template&id=7ffd6d24&", function () {
      api.rerender('7ffd6d24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/CBT/RoomCBTInfoForm.vue"
export default component.exports